import { useContext } from 'react'
import { CalendarDays, ShieldCheck } from 'lucide-react'
import ConfigContext from '@contexts/ConfigContext'
import { formatReleaseDate } from '@utils/releaseCampaign'

function ReleaseStatus({ campaign }) {
  const { releaseDate, status, statusCopy = {} } = campaign
  let content = null

  if (status === 'planned') {
    const formattedDate = formatReleaseDate(releaseDate)

    if (!statusCopy.plannedPrefix || !formattedDate) {
      return null
    }

    content = (
      <span>
        {statusCopy.plannedPrefix}{' '}
        <time dateTime={releaseDate}>{formattedDate}</time>.
      </span>
    )
  } else if (status === 'active' && statusCopy.active) {
    content = <span>{statusCopy.active}</span>
  } else if (status === 'delayed' && statusCopy.delayed) {
    content = <span>{statusCopy.delayed}</span>
  }

  return content ? (
    <div className="flex min-w-0 max-w-full items-center gap-2 pl-6 text-xs font-medium text-primary-700 [overflow-wrap:anywhere] dark:text-primary-300 sm:max-w-[50%] sm:pl-0 sm:text-sm">
      <CalendarDays aria-hidden="true" className="h-4 w-4 shrink-0" />
      {content}
    </div>
  ) : null
}

function ProductReleaseNotice({ campaign: campaignOverride }) {
  const config = useContext(ConfigContext)
  const campaign = campaignOverride ?? config?.releaseCampaign

  if (
    !campaign?.enabled ||
    !campaign.banner?.label ||
    !campaign.banner.message
  ) {
    return null
  }

  return (
    <section
      aria-labelledby="product-release-status"
      className="border-b border-primary-200 bg-primary-50/80 py-2.5 dark:border-primary-800 dark:bg-primary-900/30"
      role="status"
    >
      <div className="container flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-2.5 sm:items-center">
          <ShieldCheck
            aria-hidden="true"
            className="mt-0.5 h-4 w-4 shrink-0 text-primary-600 dark:text-primary-400 sm:mt-0"
          />
          <p className="min-w-0 text-xs leading-5 text-gray-700 [overflow-wrap:anywhere] dark:text-gray-300 sm:text-sm">
            <span
              className="mr-2 font-semibold text-gray-950 dark:text-white"
              id="product-release-status"
            >
              {campaign.banner.label}
            </span>
            {campaign.banner.message}
          </p>
        </div>

        <ReleaseStatus campaign={campaign} />
      </div>
    </section>
  )
}

export default ProductReleaseNotice
